





import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcBody2 extends Vue{
  @Prop({default:'p'})
  tag!:string
}
